var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManypixelsExpOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_166_career_outline",
    "data-name": "#166_career_outline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.61,149.05h6.64v5.38a4.36,4.36,0,0,1,.54,3.39c-.54,1.83-1.23,3.5-4.11,2.39S178.61,153.77,178.61,149.05Z",
    fill: "#ffc9b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.31,161.56a5.69,5.69,0,0,1-2-.42c-3.42-1.32-3.71-6.69-3.71-12.09a1,1,0,0,1,1-1h6.64a1,1,0,0,1,1,1v5.11a5.33,5.33,0,0,1,.5,3.94,4.7,4.7,0,0,1-2.07,3.16A3.09,3.09,0,0,1,183.31,161.56Zm-3.7-11.51c0,3.35.23,8.38,2.43,9.22a2.52,2.52,0,0,0,1.76.2c.5-.25.79-1.13,1-1.93a3.32,3.32,0,0,0-.41-2.54,1.06,1.06,0,0,1-.17-.57v-4.38Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.1,149.05h-6.64v5.38a4.36,4.36,0,0,0-.54,3.39c.54,1.83,1.22,3.5,4.11,2.39S221.1,153.77,221.1,149.05Z",
    fill: "#ffc9b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.4,161.56a3.06,3.06,0,0,1-1.37-.3A4.7,4.7,0,0,1,213,158.1a5.28,5.28,0,0,1,.5-3.94v-5.11a1,1,0,0,1,1-1h6.64a1,1,0,0,1,1,1c0,5.4-.29,10.77-3.71,12.09A5.69,5.69,0,0,1,216.4,161.56Zm-.94-11.51v4.38a.94.94,0,0,1-.18.57,3.38,3.38,0,0,0-.4,2.54c.24.8.53,1.68,1,1.93a2.52,2.52,0,0,0,1.76-.2c2.2-.84,2.41-5.87,2.43-9.22Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.91,
    y: 162.31,
    width: 10.04,
    height: 20.64,
    rx: 2.29,
    fill: "#ffbc0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,184H215.2a3.3,3.3,0,0,1-3.29-3.3v-16a3.3,3.3,0,0,1,3.29-3.3h5.46a3.3,3.3,0,0,1,3.29,3.3v16A3.3,3.3,0,0,1,220.66,184Zm-5.46-20.65a1.3,1.3,0,0,0-1.29,1.3v16a1.3,1.3,0,0,0,1.29,1.3h5.46a1.3,1.3,0,0,0,1.29-1.3v-16a1.3,1.3,0,0,0-1.29-1.3Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.93,155.36h0a1.47,1.47,0,0,1,1.47,1.47v5.49a0,0,0,0,1,0,0h-2.93a0,0,0,0,1,0,0v-5.49A1.47,1.47,0,0,1,217.93,155.36Z",
    fill: "#ffbc0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.4,163.31h-2.94a1,1,0,0,1-1-1v-5.48a2.47,2.47,0,0,1,4.94,0v5.48A1,1,0,0,1,219.4,163.31Zm-1.94-2h.94v-4.48a.47.47,0,0,0-.94,0Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.81,101.56H206.9a14.2,14.2,0,0,1,14.2,14.2v33.29a0,0,0,0,1,0,0H178.61a0,0,0,0,1,0,0V115.76A14.2,14.2,0,0,1,192.81,101.56Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.1,150.05H178.61a1,1,0,0,1-1-1V115.76a15.22,15.22,0,0,1,15.2-15.2H206.9a15.22,15.22,0,0,1,15.2,15.2v33.29A1,1,0,0,1,221.1,150.05Zm-41.49-2H220.1V115.76a13.22,13.22,0,0,0-13.2-13.2H192.81a13.22,13.22,0,0,0-13.2,13.2Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.37,55a14.85,14.85,0,0,1,2.21-.17c3.4,0,6.88-.09,10,1.44A18.9,18.9,0,0,1,221.1,73.09l-.72,14H179.53a8.51,8.51,0,0,1,.16-2.61,11.29,11.29,0,0,0-.4-2.69,38.46,38.46,0,0,1-.82-6.93,26.86,26.86,0,0,1,2.24-10.64c.83-2,1.81-4.12,3.59-5.38s4.61-1.3,5.88.48A14.26,14.26,0,0,1,198.37,55Z",
    fill: "#725858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.38,88.06H179.53a1,1,0,0,1-1-.72,4.76,4.76,0,0,1,0-2.16,5.24,5.24,0,0,0,.1-.77,7.26,7.26,0,0,0-.25-1.85c0-.2-.09-.4-.13-.61a38.87,38.87,0,0,1-.84-7.1,27.73,27.73,0,0,1,2.32-11c.84-2.07,1.92-4.39,3.93-5.81a5.59,5.59,0,0,1,6.47-.14,15.3,15.3,0,0,1,8-3.87h0a14.64,14.64,0,0,1,2.37-.18h.6c3.29,0,6.7,0,9.84,1.54A19.87,19.87,0,0,1,222.1,73.09s0,0-.72,14A1,1,0,0,1,220.38,88.06Zm-39.9-2h39c.16-3.12.67-12.88.67-13a17.86,17.86,0,0,0-10-15.91c-2.72-1.33-5.76-1.33-9-1.33h-.61A13.29,13.29,0,0,0,190.92,60a1,1,0,0,1-.8.32,1,1,0,0,1-.75-.42c-.93-1.3-3.14-1.2-4.49-.24-1.58,1.11-2.47,3-3.24,4.94a25.8,25.8,0,0,0-2.17,10.25,36.7,36.7,0,0,0,.8,6.74l.12.57a8.55,8.55,0,0,1,.3,2.37,7.7,7.7,0,0,1-.13,1C180.53,85.7,180.5,85.89,180.48,86.06Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,100.79H203a0,0,0,0,1,0,0v3.41a2.52,2.52,0,0,1-2.52,2.52h-.9A2.52,2.52,0,0,1,197,104.2v-3.41A0,0,0,0,1,197,100.79Z",
    fill: "#ffc9b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.46,107.72h-.9A3.53,3.53,0,0,1,196,104.2v-3.41a1,1,0,0,1,1-1H203a1,1,0,0,1,1,1v3.41A3.52,3.52,0,0,1,200.46,107.72ZM198,101.79v2.41a1.52,1.52,0,0,0,1.52,1.52h.9A1.52,1.52,0,0,0,202,104.2v-2.41Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 184.04,
    cy: 85.38,
    rx: 5.43,
    ry: 4.97,
    fill: "#ffc9b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,91.34a6,6,0,1,1,6.42-6A6.21,6.21,0,0,1,184,91.34Zm0-9.93a4,4,0,1,0,4.42,4A4.22,4.22,0,0,0,184,81.41Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.67,
    cy: 85.38,
    rx: 5.43,
    ry: 4.97,
    fill: "#ffc9b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.67,91.34a6,6,0,1,1,6.43-6A6.21,6.21,0,0,1,215.67,91.34Zm0-9.93a4,4,0,1,0,4.43,4A4.22,4.22,0,0,0,215.67,81.41Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,101.56h0a17.39,17.39,0,0,1-17.39-17.38V74.82s4.38-2.49,5.68-6.43c0,0,6.68,7.6,13.12,7.08a148.89,148.89,0,0,0,16-2.22V84.18A17.38,17.38,0,0,1,200,101.56Z",
    fill: "#ffc9b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,102.56a18.4,18.4,0,0,1-18.39-18.38V74.82a1,1,0,0,1,.51-.86s4.06-2.37,5.22-5.88a1,1,0,0,1,1.7-.35c.06.07,6.42,7.2,12.29,6.75a153.93,153.93,0,0,0,15.85-2.21,1,1,0,0,1,1.2,1V84.18A18.4,18.4,0,0,1,200,102.56ZM183.62,75.38v8.8a16.39,16.39,0,0,0,32.77,0V74.46c-2.49.46-8.51,1.5-14.89,2-5.35.42-10.66-4.12-12.88-6.3A15.3,15.3,0,0,1,183.62,75.38Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.92,88.06a9.15,9.15,0,0,1-1.65-.14,1,1,0,1,1,.35-2,8.53,8.53,0,0,0,1.76.09,14.76,14.76,0,0,0-1.26-3.15,1,1,0,0,1,.43-1.35,1,1,0,0,1,1.34.42c.91,1.74,1.89,4,1.38,5.17a1.35,1.35,0,0,1-.92.77A5.75,5.75,0,0,1,199.92,88.06Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.25,139.79a1,1,0,0,1-1-1v-24a1,1,0,0,1,2,0v24A1,1,0,0,1,185.25,139.79Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.46,139.69a1,1,0,0,1-1-1V114.81a1,1,0,1,1,2,0v23.88A1,1,0,0,1,214.46,139.69Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.25,
    y: 138.79,
    width: 11.47,
    height: 56.16,
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.71,196H185.25a1,1,0,0,1-1-1V138.79a1,1,0,0,1,1-1h11.46a1,1,0,0,1,1,1V195A1,1,0,0,1,196.71,196Zm-10.46-2h9.46V139.79h-9.46Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.52,
    y: 138.79,
    width: 9.94,
    height: 56.16,
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.46,196h-9.94a1,1,0,0,1-1-1V138.79a1,1,0,0,1,1-1h9.94a1,1,0,0,1,1,1V195A1,1,0,0,1,214.46,196Zm-8.94-2h7.94V139.79h-7.94Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.8,
    y: 138.69,
    width: 28.66,
    height: 11.67,
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.46,151.36H185.8a1,1,0,0,1-1-1V138.69a1,1,0,0,1,1-1h28.66a1,1,0,0,1,1,1v11.67A1,1,0,0,1,214.46,151.36Zm-27.66-2h26.66v-9.67H186.8Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.28 194.94 195.28 202.27 179.74 202.27 187.51 194.94 195.28 194.94",
    fill: "#f56132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.28,203.27H179.74a1,1,0,0,1-.93-.63,1,1,0,0,1,.24-1.1l7.77-7.32a1,1,0,0,1,.69-.27h7.77a1,1,0,0,1,1,1v7.32A1,1,0,0,1,195.28,203.27Zm-13-2h12V196h-6.37Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.14 194.94 205.14 202.27 220.68 202.27 212.91 194.94 205.14 194.94",
    fill: "#f56132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.68,203.27H205.14a1,1,0,0,1-1-1V195a1,1,0,0,1,1-1h7.77a1,1,0,0,1,.69.27l7.76,7.32a1,1,0,0,1-.68,1.73Zm-14.54-2h12L212.51,196h-6.37Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.52,
    y: 107.43,
    width: 5.07,
    height: 3.99,
    rx: 1.47,
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.12,112.42H199a2.48,2.48,0,0,1-2.47-2.47v-1a2.48,2.48,0,0,1,2.47-2.47h2.13a2.48,2.48,0,0,1,2.47,2.47v1A2.48,2.48,0,0,1,201.12,112.42Zm-2.13-4a.47.47,0,0,0-.47.47v1a.47.47,0,0,0,.47.47h2.13a.47.47,0,0,0,.47-.47v-1a.47.47,0,0,0-.47-.47Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.6 111.42 195.66 127.44 200.23 134.74 204.05 128.12 201.51 111.42 198.6 111.42",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.23,135.74a1,1,0,0,1-.85-.46L194.81,128a1,1,0,0,1-.14-.71l3-16a1,1,0,0,1,1-.82h2.91a1,1,0,0,1,1,.85L205,128a1,1,0,0,1-.12.65l-3.82,6.62a1,1,0,0,1-.85.5Zm-3.52-8.5,3.49,5.56,2.81-4.88-2.36-15.5h-1.21Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.95,
    y: 164.61,
    width: 2.02,
    height: 9.13,
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,174.74h-2a1,1,0,0,1-1-1v-9.13a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1v9.13A1,1,0,0,1,225,174.74Zm-1-2h0l0-7.13Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.86,
    y: 216.21,
    width: 53.72,
    height: 24.08,
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.57,241.3H106.86a1,1,0,0,1-1-1V216.21a1,1,0,0,1,1-1h53.71a1,1,0,0,1,1,1V240.3A1,1,0,0,1,160.57,241.3Zm-52.71-2h51.71V217.21H107.86Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.14,
    y: 202.23,
    width: 53.72,
    height: 38.06,
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.86,241.3H173.14a1,1,0,0,1-1-1V202.23a1,1,0,0,1,1-1h53.72a1,1,0,0,1,1,1V240.3A1,1,0,0,1,226.86,241.3Zm-52.72-2h51.72V203.23H174.14Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.43,
    y: 167.89,
    width: 53.72,
    height: 72.41,
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.14,241.3H239.43a1,1,0,0,1-1-1V167.89a1,1,0,0,1,1-1h53.71a1,1,0,0,1,1,1V240.3A1,1,0,0,1,293.14,241.3Zm-52.71-2h51.71V168.89H240.43Z",
    fill: "#093f68"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManypixelsExpOutline);
export default __webpack_public_path__ + "static/media/Manypixels_Exp_Outline.b483bf964133219ceb80eeacb5b216ce.svg";
export { ForwardRef as ReactComponent };